import React from "react";

const dictionary = {
  close: "Close",
  loading: "Loading...",
  "errors.stationFrom.required": "Please select a station",
  "errors.stationTo.required": "Please select a station",
  "errors.stationFrom.sameOrigin": "Origin and destination stations must be different",
  "errors.stationTo.sameOrigin": "Origin and destination stations must be different",
  "errors.viaAvoid.required": "Please select a station",
  "errors.toDateTime.returnNotEarlier": (
    <span>
      Your return journey is earlier than
      <br />
      your outward journey
    </span>
  ),
  "errors.toDateTime.seasonNotEarlier": (
    <span>
      Your ending date should be earlier
      <br />
      than your starting date
    </span>
  ),
  "errors.toDateTime.seasonMinDuration": (
    <span>
      Your ending date should be at least
      <br />1 month after your starting date
    </span>
  ),
  "errors.fromDateTime.smartCarnetStartNoLater": <span>Choose a start date within a month</span>,
  "location.error.unknown": (
    <span>
      Unknown error while determining
      <br /> your location in your browser
    </span>
  ),
  "location.error.userDenied": (
    <span>
      You have blocked geolocation for this website.
      <br /> Change your browser settings manually.
    </span>
  ),
  "location.error.unavailable": (
    <span>
      Unable to determine your location.
      <br />
      Please try later
    </span>
  ),
  "location.error.noResults": (
    <span>
      No stations found. Please try
      <br /> at a different location
    </span>
  ),
  "station.findStation": "Find a station",
  "station.avoid.placeholder": "Avoiding...",
  "station.from.placeholder": "Leaving from...",
  "station.from.aria": "Leaving from",
  "station.container.from.aria": "Origin station",
  "station.to.placeholder": "Going to...",
  "station.to.aria": "Going to",
  "station.container.to.aria": "Destination station",
  "station.via.placeholder": "Going via...",
  "station.via": "Via/Avoid",
  "station.via.aria": "Via/Avoid station",
  "tabs.other": "Other",
  "tabs.other.aria": "Other tickets",
  "tabs.favourites": "Favourites",
  "tabs.favourites.aria": "Favourites",
  "tickets.smart.carnet.radio": "keyGo Carnet",
  "tickets.smart.carnet.radio.subtitle-1": "Set of one-way discounted tickets (limited routes).",
  "tickets.smart.carnet.radio.subtitle-2":
    "Sold in sets of 5 one-way tickets, peak and off-peak, valid for 3 months from start date.",
  "tickets.smart.carnet.find-more": "Find out more",
  "tickets.rover.radio": "Rover tickets",
  "tickets.rover.radio.subtitle": "Unlimited travel within a specified area",
  "tickets.rover.select.aria": "Select a ticket type.",
  "tickets.daysave.radio": "DaySave",
  "tickets.daysave.radio.subtitle": "For unlimited Off-Peak travel",
  "tabs.season": "Season",
  "tabs.season.aria": "Season tickets",
  "tabs.tickets": "Tickets",
  "tabs.tickets.aria": "Tickets",
  "tickets.submit": "Find trains",
  "tickets.radio.aria": "Ticket type",
  "tickets.season.checkbox.aria": "Season Ticket type",
  "tickets.date.depart.aria": "Depart date/time",
  "tickets.date.return.aria": "Return date/time",
  "tickets.submit.long": "Find times & tickets",
  "tickets.submitCarnet.long": "Buy tickets",
  "passengers.label.smart.carnet.mobile":
    "To purchase, you will need a Key Smartcard with keyGo enabled.",
  "station.noResults": "No results found",
  "station.results.aria": "Stations list",
  "favourites.loading.message": "Loading your favourite ticket…",
  "favourites.login.message": "Log in to quickly purchase your favourite tickets",
  "favourites.login.button": "Log in",
  "favourites.empty.message": "You haven't got any favourite tickets!",
  "favourites.empty.helper.message": "Look for the heart when purchasing your ticket to save the ticket as a favourite.",
  "favourites.empty.helper.button": "Add to favourites",
  "favourites.ticket.stations.aria": "{origin} to {destination}.",
  "favourites.ticket.fareClass.firstClass": "First Class",
  "favourites.ticket.fareClass.firstClass.aria": "First class.",
  "favourites.ticket.fareClass.standard": "Standard",
  "favourites.ticket.fareClass.standard.aria": "Standard class.",
  "favourites.ticket.remove.button": "Remove favourite",
  "favourites.ticket.remove.confirm.message": "Are you sure you want to remove this ticket from your favourites?",
  "favourites.ticket.remove.confirm.aria": "Click to remove",
  "favourites.ticket.remove.confirm.button": "Remove",
  "favourites.ticket.remove.cancel.button": "Cancel",
  "favourites.form.delivery.change.button": "Change",
  "favourites.form.submit.payment": "Payment Details",
  "favourites.form.submit.delivery": "Delivery Options",
  "favourites.ticketSelection.linkTextHelper": "Not the ticket you're looking for?",
  "favourites.ticketSelection.linkText": "Select another favourite ticket",
  "favourites.ticketSelection.list.header": "Select a favourite ticket",
  "favourites.ticketSelection.list.aria": "Ticket {index} of {total}.",
  "favourites.ticketSelection.confirm": "Done",
  "favourites.ticketSelection.confirm.aria": "Choose selected ticket",
  "favourites.ticketSelection.close": "Close",
  "flexi.modal.heading": "What is a Flexi Season ticket?",
  "flexi.modal.bodyCopy1": "Flexi Season tickets are valid for a 28-Day period and entitle you to 8 days of travelling between the stations specified, within that 28-Day period.",
  "flexi.modal.bodyCopy2": "If you make the same journey twice a week you will find that, on most routes, Flexi Season Tickets offer better value for money compared to buying daily tickets.",
  "flexi.modal.bodyCopy3": "You can travel at peak and off peak times, and you don’t need to tell us in advance what days you plan to travel.",
  "flexi.modal.bodyCopy4": "You must activate a day’s worth of travel in your Flexi Season before you board a train service.",
  "flexi.modal.bodyCopy5": "Flexi Season Tickets can be purchased online and at some ticket offices.",
  "flexi.modal.moreInfo": "More info",
  "flexi.modal.close": "Close",
  "flexi.infoLink.GN": "https://www.greatnorthernrail.com/flexiseason",
  "flexi.infoLink.SE": "https://www.southeasternrailway.co.uk/tickets/tickets-explained/flexi-season-tickets",
  "flexi.infoLink.SN": "https://www.southernrailway.com/flexiseason",
  "flexi.infoLink.TL": "https://www.thameslinkrailway.com/flexiseason",
  "flexi.infoLink.TP": "https://www.tpexpress.co.uk/train-tickets/season-tickets/flexi-season-tickets",
  "adult": "Adult",
  "adults": "Adults",
  "child": "Child",
  "children": "Children",
  "noBookingFees": "No booking fees!",
};

export default dictionary;
